/**
 * コレクションフィルタ & 表示切替システム
 */

/**
 * カラー大分類マッピング
 */
const COLOR_MAPPING = {
  "lightbeige-brown": "ivory",
  "black": "black",
  "navy": "navy",
  "red": "red",
  "brown": "brown",
  "camel": "camel",
  "green": "dgreen",
  "lightgreen": "lgreen",
  "lightblue": "sax",
  "lightbeige": "ivory",
  "lightpink": "pink",
  "shellpink": "pink",
  "sweetpink": "pink",
  "lavender": "lavender",
  "black-blue": "black2",
  "black-red": "black2",
  "black-purple": "black2",
  "black-brown": "black2",
  "black-yellow": "black2",
  "black-gold": "black2",
  "black-silver": "black2",
  "black-lightbeige": "black2",
  "lightbeige-black": "ivory",
  "red-black": "red",
  "navy-brown": "navy",
  "green-brown": "dgreen",
  "camel-brown": "camel",
  "navy-blue": "navy",
  "navy-lightblue": "navy",
  "navy-green": "navy",
  "lightpink-lightbeige": "pink",
  "lightblue-lightbeige": "sax",
  "yellow-lightbeige": "lgreen",
  "lavender-shellpink": "lavender",
  "mintgreen-lavender": "sax",
  "momofuji-lightpink": "pink",
  "wakakusa": "lgreen",
  "syu": "red",
  "momofuji": "pink",
  "sumire": "lavender",
  "aohisui": "sax",
  "rikyu": "lgreen"
};

class CollectionFilter {
  constructor(container) {
    this.isInitialLoad = true;
    this.container = container;
    this.productGrid = container.querySelector('#product-grid');
    this.sortSelect = container.querySelector('#sort-by');
    this.changeBtns = container.querySelectorAll('.change-btn a');
    this.filterCheckboxes = container.querySelectorAll('.collection-side input[type="checkbox"]');
    this.priceMinInput = document.querySelector('#priceMinInput');
    this.priceMaxInput = document.querySelector('#priceMaxInput');
    this.priceDecisionBtn = container.querySelector('.price-decision-btn');
    this.loadMoreBtn = document.querySelector('#load-more-btn');
    this.loadMoreWrapper = document.querySelector('#load-more-wrapper');
    this.keywordInput = container.querySelector('#collectionKeywordInput');

    // URLパラメータから表示モードを復元（なければdata属性のデフォルト値を使用）
    const urlDisplayMode = new URLSearchParams(window.location.search).get('display_mode');
    this.currentMode = this.container.dataset.displayMode || urlDisplayMode || 'all-variant';
    this.currentSort = 'manual';
    this.itemsPerPage = parseInt(this.container.dataset.itemsPerPage) || 20;
    this.displayedItems = this.itemsPerPage; // 最初に表示するアイテム数

    this.currentFilters = {
      color: [],
      material: [],
      series: [],
      salestype: [],
      minPrice: 0,
      maxPrice: 200000,
      keyword: ''
    };

    // console.log('CollectionFilter initialized:', {
    //   mode: this.currentMode,
    //   itemsPerPage: this.itemsPerPage,
    //   items: this.productGrid.querySelectorAll('.collection-items').length
    // });

    this.init();
  }

  init() {
  this.initPriceFilter();
  this.initKeywordSearch();
  this.initModeSwitch();
  this.updateModeButtons();
  this.initSort();
  this.initFilters();
  this.initLoadMore();
  this.initSidebarToggle();

  this.updateLoadMore();
  this.isInitialLoad = false;
}

  /**
   * URLパラメータをクリア
   */
  clearURLParams() {
    const url = new URL(window.location);
    const sortBy = url.searchParams.get('sort_by');
    const displayMode = url.searchParams.get('display_mode');

    // sort_by, display_mode以外のパラメータをクリア
    url.search = '';
    if (sortBy) {
      url.searchParams.set('sort_by', sortBy);
    }
    if (displayMode) {
      url.searchParams.set('display_mode', displayMode);
    }

    window.history.replaceState({}, '', url);
  }

  /**
   * 初期表示を設定（全アイテムを一度表示してから適切なモードを適用）
   */
  setInitialDisplay() {
    const items = this.productGrid.querySelectorAll('.collection-items');
    // console.log('Setting initial display for', items.length, 'items. Mode:', this.currentMode);

    let visibleCount = 0;
    items.forEach(item => {
      const itemMode = item.dataset.mode;

      // 初期表示時はモードのみで判定（フィルタは未適用）
      if (this.currentMode === 'all-variant') {
        const show = itemMode === 'variant';
        item.style.display = show ? '' : 'none';
        if (show) visibleCount++;
      } else {
        const show = itemMode === 'product';
        item.style.display = show ? '' : 'none';
        if (show) visibleCount++;
      }
    });

    // console.log('Initial display set:', visibleCount, 'visible items out of', items.length);

    // 初期表示数に応じてアイテムを表示/非表示
    this.displayedItems = this.itemsPerPage;
    this.updateLoadMore();
  }

  /**
   * 価格フィルタの初期化（直接入力式）
   */
  initPriceFilter() {
    if (!this.priceMinInput || !this.priceMaxInput || !this.priceDecisionBtn) return;

    // 初期値を設定
    if (this.priceMinInput.value) {
      this.currentFilters.minPrice = parseInt(this.priceMinInput.value);
    }
    if (this.priceMaxInput.value) {
      this.currentFilters.maxPrice = parseInt(this.priceMaxInput.value);
    }

    // 決定ボタンのイベント
    this.priceDecisionBtn.addEventListener('click', () => {
      const minPrice = parseInt(this.priceMinInput.value) || 0;
      const maxPrice = parseInt(this.priceMaxInput.value) || 200000;

      // 最小値が最大値より大きい場合は入れ替え
      if (minPrice > maxPrice) {
        this.currentFilters.minPrice = maxPrice;
        this.currentFilters.maxPrice = minPrice;
        this.priceMinInput.value = maxPrice;
        this.priceMaxInput.value = minPrice;
      } else {
        this.currentFilters.minPrice = minPrice;
        this.currentFilters.maxPrice = maxPrice;
      }

      // console.log('💰 価格フィルタ適用:', {
      //   最小価格: this.currentFilters.minPrice,
      //   最大価格: this.currentFilters.maxPrice
      // });

      this.applyFilters();
    });
  }

  /**
   * サイドバー開閉の初期化（SPサイズ用）
   */
  initSidebarToggle() {
    const collectionSide = document.querySelector('.collection-side');
    const sideTtl = document.querySelector('.collection-side .side-ttl');

    if (!collectionSide || !sideTtl) return;

    sideTtl.addEventListener('click', () => {
      collectionSide.classList.toggle('is-open');
    });
  }

  /**
   * 表示モード切替の初期化
   */
  initModeSwitch() {
  this.changeBtns.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const mode = btn.dataset.mode;

      if (mode === this.currentMode) return;

      this.currentMode = mode;
      this.updateModeButtons();

      const url = new URL(window.location);
      if (this.currentMode === 'all-variant') {
        url.searchParams.delete('display_mode');
      } else {
        url.searchParams.set('display_mode', this.currentMode);
      }
      window.history.replaceState({}, '', url);

      this.switchDisplayMode();
    });
  });
}

  /**
   * 表示モードを切り替える
   */
  switchDisplayMode() {
    const items = this.productGrid.querySelectorAll('.collection-items');
    let visibleCount = 0;

    items.forEach(item => {
      const itemMode = item.dataset.mode;

      // フィルタリングを考慮した表示切替
      if (this.hasActiveFilters()) {
        // フィルタがアクティブな場合は shouldShowItem で判定
        const shouldShow = this.shouldShowItem(item);
        item.style.display = shouldShow ? '' : 'none';
        if (shouldShow) visibleCount++;
      } else {
        // フィルタがない場合はモードのみで判定
        if (this.currentMode === 'all-variant') {
          item.style.display = itemMode === 'variant' ? '' : 'none';
          if (itemMode === 'variant') visibleCount++;
        } else {
          item.style.display = itemMode === 'product' ? '' : 'none';
          if (itemMode === 'product') visibleCount++;
        }
      }
    });

    // モード切替後にソートを再適用
    this.applySort();

    // もっと見るボタンを更新
    this.displayedItems = this.itemsPerPage; // 表示数をリセット
    this.updateLoadMore();

    // console.log(`Mode switched: ${visibleCount}/${items.length} visible`);
  }

  /**
   * アクティブなフィルタがあるかチェック
   */
  hasActiveFilters() {
  return (
    this.currentFilters.color.length > 0 ||
    this.currentFilters.material.length > 0 ||
    this.currentFilters.series.length > 0 ||
    this.currentFilters.salestype.length > 0 ||
    this.currentFilters.minPrice > 0 ||
    this.currentFilters.maxPrice < 200000 ||
    this.currentFilters.keyword !== ''
  );
}

  updateModeButtons() {
    this.changeBtns.forEach(btn => {
      const isActive = btn.dataset.mode === this.currentMode;
      btn.parentElement.classList.toggle('active', isActive);
    });
  }

  /**
   * 並べ替えの初期化
   */
  initSort() {
    if (!this.sortSelect) return;

    // URLパラメータから並び順を復元
    const urlParams = new URLSearchParams(window.location.search);
    const sortBy = urlParams.get('sort_by');
    if (sortBy) {
      this.sortSelect.value = sortBy;
      this.currentSort = sortBy;
    } else {
      // sort_byパラメータがない場合はmanualを選択
      this.sortSelect.value = 'manual';
      this.currentSort = 'manual';
    }

    // 初期ソートを適用
    this.applySort();

    this.sortSelect.addEventListener('change', (e) => {
      const sortValue = e.target.value || 'manual';

      // console.log('🔄 並べ替え実行（ページリロード）:', sortValue);

      // sort_byパラメータ付きでページをリロード（表示モードも保持）
      const url = new URL(window.location);
      url.search = '';
      if (sortValue !== 'manual') {
        url.searchParams.set('sort_by', sortValue);
      }
      if (this.currentMode !== 'all-variant') {
        url.searchParams.set('display_mode', this.currentMode);
      }
      window.location.href = url.toString();
    });
  }

  /**
   * ソート実行
   */
  applySort() {
    const items = Array.from(this.productGrid.querySelectorAll('.collection-items'));
    const sortValue = this.currentSort || 'manual';

    // 現在のモードに合ったアイテムのみをフィルタ
    const targetItems = items.filter(item => {
      if (this.currentMode === 'all-variant') {
        return item.dataset.mode === 'variant';
      } else {
        return item.dataset.mode === 'product';
      }
    });

    // manual/best-sellingの場合は元の順序を維持（DOMの並べ替え不要）
    if (sortValue === 'manual' || sortValue === 'best-selling') {
      // console.log('⭐ おすすめ順 / 人気順（元の順序を維持）');
      return;
    }

    // ソート関数
    let sortedItems = [...targetItems];

    switch (sortValue) {
      case 'price-ascending':
        sortedItems.sort((a, b) => {
          const priceA = parseInt(a.dataset.price) || 0;
          const priceB = parseInt(b.dataset.price) || 0;
          return priceA - priceB;
        });
        // console.log('💰 価格の安い順でソート');
        break;

      case 'price-descending':
        sortedItems.sort((a, b) => {
          const priceA = parseInt(a.dataset.price) || 0;
          const priceB = parseInt(b.dataset.price) || 0;
          return priceB - priceA;
        });
        // console.log('💰 価格の高い順でソート');
        break;

      case 'title-ascending':
        sortedItems.sort((a, b) => {
          const titleA = (a.dataset.title || '').toLowerCase();
          const titleB = (b.dataset.title || '').toLowerCase();
          return titleA.localeCompare(titleB, 'ja');
        });
        // console.log('📝 商品名 A-Z でソート');
        break;

      case 'title-descending':
        sortedItems.sort((a, b) => {
          const titleA = (a.dataset.title || '').toLowerCase();
          const titleB = (b.dataset.title || '').toLowerCase();
          return titleB.localeCompare(titleA, 'ja');
        });
        // console.log('📝 商品名 Z-A でソート');
        break;

      case 'created-ascending':
        sortedItems.sort((a, b) => {
          const createdA = a.dataset.created || '0';
          const createdB = b.dataset.created || '0';
          return createdA.localeCompare(createdB);
        });
        // console.log('📅 登録日の古い順でソート');
        break;

      case 'created-descending':
        sortedItems.sort((a, b) => {
          const createdA = a.dataset.created || '0';
          const createdB = b.dataset.created || '0';
          return createdB.localeCompare(createdA);
        });
        // console.log('📅 新着順でソート');
        break;
    }

    // DOM要素を並べ替え
    sortedItems.forEach(item => {
      this.productGrid.appendChild(item);
    });

    // console.log(`✅ ${sortedItems.length}件のアイテムを並べ替えました`);
  }

  /**
   * フィルタの初期化
   */
  /**
 * キーワード検索の初期化
 */
initKeywordSearch() {
  this.keywordInput = document.querySelector('#collectionKeywordInput');

  if (!this.keywordInput) return;

  this.keywordInput.addEventListener('input', () => {
    this.currentFilters.keyword = this.keywordInput.value.trim().toLowerCase();
    this.applyFilters();
  });
}
  initFilters() {
    // URLパラメータからフィルタ状態を復元
    const urlParams = new URLSearchParams(window.location.search);
    const filterKeys = ['color', 'material', 'series', 'salestype'];
    let hasInitialFilter = false;

    filterKeys.forEach(key => {
      const paramValue = urlParams.get(key);
      if (paramValue) {
        // カンマ区切りで複数の値に対応 (例: ?color=Red,Blue)
        const values = paramValue.split(',').map(v => v.trim());

        // 既存の配列に追加（重複チェック）
        values.forEach(val => {
          if (!this.currentFilters[key].includes(val)) {
            this.currentFilters[key].push(val);
          }
        });

        hasInitialFilter = true;

        // チェックボックスの状態を更新
        values.forEach(val => {
          const checkbox = Array.from(this.filterCheckboxes).find(
            cb => cb.name === key && cb.value === val
          );
          if (checkbox) {
            checkbox.checked = true;
          }
        }); 
      }
    });

    if (hasInitialFilter) {
      // console.log('🔗 URLパラメータからフィルタを適用しました');
      this.applyFilters();
    }

    // カラーフィルタの値を確認
    const colorCheckboxes = Array.from(this.filterCheckboxes).filter(cb => cb.name === 'color');
    if (colorCheckboxes.length > 0) {
      // console.log('🎨 Color filter options:', colorCheckboxes.map(cb => cb.value));
    }

    // 最初の数アイテムのカラーデータを確認
    const items = this.productGrid.querySelectorAll('.collection-items');
    const variantItems = Array.from(items).filter(i => i.dataset.mode === 'variant').slice(0, 3);
    const productItems = Array.from(items).filter(i => i.dataset.mode === 'product').slice(0, 3);

    // console.log('🔍 Sample variant items colors:', variantItems.map(i => i.dataset.color));
    // console.log('🔍 Sample product items variants:', productItems.map(i => i.dataset.variants));

    this.filterCheckboxes.forEach(checkbox => {
      checkbox.addEventListener('change', (e) => {
        const filterType = e.target.name;
        const filterValue = e.target.value;

        if (e.target.checked) {
          // チェックON: 配列に追加
          if (!this.currentFilters[filterType].includes(filterValue)) {
            this.currentFilters[filterType].push(filterValue);
          }
        } else {
          // チェックOFF: 配列から削除
          this.currentFilters[filterType] = this.currentFilters[filterType].filter(
            v => v !== filterValue
          );
        }

        // console.log(`🔧 フィルタ変更 [${filterType}]:`, {
        //   追加削除した値: filterValue,
        //   チェック: e.target.checked ? 'ON' : 'OFF',
        //   現在の配列: this.currentFilters[filterType]
        // });

        this.applyFilters();
      });
    });
  }

  /**
   * フィルタリング実行
   */
  applyFilters() {
    if (this.isInitialLoad && !this.hasActiveFilters()) return;
    const items = this.productGrid.querySelectorAll('.collection-items');
    const noProductsMessage = this.productGrid.querySelector('.no-products-message');
    let visibleCount = 0;

    // デバッグフラグをリセット
    this._firstColorCheck = false;
    this._itemDebugLogged = false;

    // console.log('━━━━━━━━━━━━━━━━━━━━━━');
    // console.log('🔄 フィルタ適用');
    // console.log('  モード:', this.currentMode);
    // console.log('  カラーフィルタ:', this.currentFilters.color);
    // console.log('  価格範囲:', `¥${this.currentFilters.minPrice.toLocaleString()} ～ ¥${this.currentFilters.maxPrice.toLocaleString()}`);
    // console.log('  素材フィルタ:', this.currentFilters.material);
    // console.log('  シリーズフィルタ:', this.currentFilters.series);
    // console.log('  販売タイプフィルタ:', this.currentFilters.salestype);
    // console.log('  全アイテム数:', items.length);

    items.forEach(item => {
  const shouldShow = this.shouldShowItem(item);

  item.style.display = shouldShow ? '' : 'none';

  if (shouldShow) visibleCount++;
});

    // 0件メッセージの表示/非表示
    if (noProductsMessage) {
      noProductsMessage.style.display = visibleCount === 0 ? 'block' : 'none';
    }

    // フィルタ適用後にソートを再適用
    this.applySort();

    // もっと見るボタンを更新
    this.displayedItems = this.itemsPerPage; // 表示数をリセット
    this.updateLoadMore();

    // URLパラメータを更新
    this.updateURLParams();

    // console.log(`✅ 結果: ${visibleCount}件表示 / ${items.length}件中`);
    // console.log('━━━━━━━━━━━━━━━━━━━━━━');
  }

  /**
   * 現在のフィルタ状態をURLパラメータに反映
   */
  updateURLParams() {
    const url = new URL(window.location);
    const filterKeys = ['color', 'material', 'series', 'salestype'];

    filterKeys.forEach(key => {
      const values = this.currentFilters[key];
      if (values && values.length > 0) {
        url.searchParams.set(key, values.join(','));
      } else {
        url.searchParams.delete(key);
      }
    });

    window.history.replaceState({}, '', url);
  }

  /**
   * アイテムを表示するべきか判定
   */
  shouldShowItem(item) {
  const itemMode = item.dataset.mode;
  const itemPrice = parseInt(item.dataset.price) || 0;
  const itemTagsArray = (item.dataset.tags || '').split(',').map(tag => tag.trim().toLowerCase());

  const keyword = this.currentFilters.keyword || '';
  const itemTitle = (item.dataset.title || '').toLowerCase();
  const itemTagsText = (item.dataset.tags || '').toLowerCase();
  const searchText = itemTitle + ' ' + itemTagsText;

  // 表示モードチェック
  if (this.currentMode === 'all-variant' && itemMode !== 'variant') {
    return false;
  }
  if (this.currentMode === 'simple' && itemMode !== 'product') {
    return false;
  }

  // キーワード検索
  if (keyword && !searchText.includes(keyword)) {
    return false;
  }
    // 価格フィルタ（範囲指定）
    if (itemPrice < this.currentFilters.minPrice || itemPrice > this.currentFilters.maxPrice) {
      return false;
    }

    // カラーフィルタ（複数選択=OR条件）
    if (this.currentFilters.color.length > 0) {
      let colorMatch = false;

      if (this.currentMode === 'all-variant') {
        // バリエーション表示モード
        const itemColor = item.dataset.color || '';
        // マッピングがあれば大分類に変換、なければそのまま使用
        const itemCategory = COLOR_MAPPING[itemColor] || itemColor;
        colorMatch = this.currentFilters.color.includes(itemCategory);
      } else {
        // 商品表示モード
        const itemVariants = (item.dataset.variants || '').split(',').map(v => v.trim()).filter(v => v);
        // 全バリエーションを大分類に変換
        const itemCategories = itemVariants.map(v => COLOR_MAPPING[v] || v);
        // いずれかのバリエーションが選択されたカテゴリに含まれるか
        colorMatch = this.currentFilters.color.some(filterColor => itemCategories.includes(filterColor));
      }

      if (!colorMatch) {
        return false;
      }
    }

    // 素材フィルタ（完全一致）
    if (this.currentFilters.material.length > 0) {
      const hasMaterial = this.currentFilters.material.some(material => {
        return itemTagsArray.includes(material.toLowerCase());
      });

      if (!hasMaterial) {
        return false;
      }
    }

    // シリーズフィルタ（完全一致）
    if (this.currentFilters.series.length > 0) {
      const hasSeries = this.currentFilters.series.some(series => {
        return itemTagsArray.includes(series.toLowerCase());
      });

      if (!hasSeries) {
        return false;
      }
    }

    // 販売タイプフィルタ（完全一致）
    if (this.currentFilters.salestype.length > 0) {
      const hasSalesType = this.currentFilters.salestype.some(type => {
        return itemTagsArray.includes(type.toLowerCase());
      });

      if (!hasSalesType) {
        return false;
      }
    }

    return true;
  }

  /**
   * もっと見るボタンの初期化
   */
  initLoadMore() {
    if (!this.loadMoreBtn) return;

    this.loadMoreBtn.addEventListener('click', () => {
      this.displayedItems += this.itemsPerPage;
      this.updateLoadMore();
    });

    // console.log('もっと見るボタン初期化完了');
  }

  /**
   * もっと見るボタンの表示を更新
   */
  updateLoadMore() {
  const items = Array.from(this.productGrid.querySelectorAll('.collection-items'));

  // 初回はLiquidで表示されているものをそのまま使う
  if (this.isInitialLoad) {
    const initiallyVisibleItems = items.filter(item => item.style.display !== 'none');

    items.forEach(item => {
      item.style.display = 'none';
    });

    initiallyVisibleItems.forEach((item, index) => {
      if (index < this.displayedItems) {
        item.style.display = '';
      }
    });

    if (this.loadMoreWrapper) {
      this.loadMoreWrapper.style.display =
        initiallyVisibleItems.length > this.displayedItems ? 'flex' : 'none';
    }

    return;
  }

  const visibleItems = items.filter(item => {
    const itemMode = item.dataset.mode;

    if (this.currentMode === 'all-variant' && itemMode !== 'variant') {
      return false;
    }
    if (this.currentMode === 'simple' && itemMode !== 'product') {
      return false;
    }

    return this.shouldShowItem(item);
  });

  items.forEach(item => {
    item.style.display = 'none';
  });

  visibleItems.forEach((item, index) => {
    if (index < this.displayedItems) {
      item.style.display = '';
    }
  });

  if (this.loadMoreWrapper) {
    this.loadMoreWrapper.style.display =
      visibleItems.length > this.displayedItems ? 'flex' : 'none';
  }
}
} 

function initCollectionFilter(event) {
  const scope = event?.target || document;
  const collectionContainer = scope.querySelector?.('#CollectionProductGrid') || document.querySelector('#CollectionProductGrid');
  if (!collectionContainer) return;

  new CollectionFilter(collectionContainer);
}

document.addEventListener('DOMContentLoaded', initCollectionFilter);
document.addEventListener('shopify:section:load', initCollectionFilter);
document.addEventListener('shopify:section:reorder', initCollectionFilter);
